import { Button, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Link } from 'react-router-dom'
import { useGetAccountAction } from 'modules/Services/hooks/useGetAccountAction'
import { ActionTooltip } from 'modules/Services/Network/subcomponents/AccountsList/subcomponents'

export const ActionLink = ({
  action,
  id,
  type,
  login,
  i18n,
  className = '',
  auto_replenishment,
  extra_info = [],
  fullWidth = false,
  hideLabel = false,
  ...rest
}) => {
  const pathGen = useGeneratePathI18n()
  const config = useGetAccountAction(action)
  const { t } = useTranslation(['services'])

  if (!config) {
    return null
  }

  const { component: Component = null, ...restConfig } = config

  const noLabel = useMemo(
    () => !fullWidth && (restConfig?.hideLabel ? restConfig?.hideLabel() : hideLabel),
    [restConfig, hideLabel, fullWidth],
  )

  return (
    <ActionTooltip
      action={action}
      disabled={!noLabel}
    >
      {Component ? (
        <Component
          fullWidth={fullWidth}
          i18n={i18n}
          type={type}
          id={id}
          login={login}
          action={action}
          className={className}
          auto_replenishment={auto_replenishment}
          extra_info={extra_info}
          {...restConfig}
          noLabel={noLabel}
          to={pathGen(restConfig.url, {
            i18n,
            networkType: type,
            accountId: id,
          })}
          {...rest}
        />
      ) : (
        <Button
          fullWidth={fullWidth}
          variant={'ghost'}
          size={'s'}
          startIcon={
            <Icon
              name={restConfig.icon}
              color={rest.iconColor ?? 'inherit'}
            />
          }
          component={Link}
          className={className}
          to={pathGen(restConfig.url, {
            i18n,
            networkType: type,
            accountId: id,
          })}
          color={restConfig.color}
          noLabel={noLabel}
          {...config}
          {...rest}
        >
          {t(`services::account_list.extra_actions.${action}`)}
        </Button>
      )}
    </ActionTooltip>
  )
}

ActionLink.propTypes = {
  action: PropTypes.string,
  id: PropTypes.number,
  type: PropTypes.string,
  i18n: PropTypes.string,
  className: PropTypes.string,
  login: PropTypes.string,
  noLabel: PropTypes.bool,
  auto_replenishment: PropTypes.object,
  fullWidth: PropTypes.bool,
  hideLabel: PropTypes.bool,
  extra_info: PropTypes.array,
}
